$(document).ready(function(){
  setTimeout(function(){
    $('.mv').addClass('on');
    setTimeout(function(){
      $('.mv_center').css('transition','0ms');
    },1200);
  },400);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.lang_switcher ul li').click(function(){
    var lang = $(this).data('lang');
    $('.lang_switcher ul li').removeClass('selected');
    $(this).addClass('selected');
    $('.wrapper').removeClass('jp');
    $('.wrapper').removeClass('en');
    $('.wrapper').addClass(lang);
  });

  $('.header_menu_btn').click(function(){
    $('header').toggleClass('open');
  });

  $('.header_menu a').click(function(){
    $('header').removeClass('open');
  });

});
